
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Où est-il utilisé?`}</em></p>
    <p>{`Il a été approuvé par le Canada. Son utilisation urgente a notamment été
autorisée dans l’Union européenne, aux Etats-Unis, en Israël et en
Grande-Bretagne. Il a également été
`}<a parentName="p" {...{
        "href": "https://www.who.int/fr/news-room/feature-stories/detail/the-moderna-covid-19-mrna-1273-vaccine-what-you-need-to-know"
      }}>{`validé par l'OMS`}</a>{`.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;